// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_radar_bob_styles" + "." + "afd0fe17" + ".chunk.css";
};